import React, { useState } from 'react';
import Layout from '../../components/layout';
import SubLayout from '../../components/layout/SubLayout';
import Chat from './index';

const ChatWithLayout = () => {
  const [showArchived, setShowArchived] = useState(false);
  
  return (
    <Layout>
      <SubLayout page={showArchived ? "Archive List" : "Chats"} showSearch whiteBg>
      <Chat showArchived={showArchived} setShowArchived={setShowArchived} />
          </SubLayout>
    </Layout>
  );
};

export default ChatWithLayout;